<h2 class="_sansSerif _primary"[i18nKey]="'intro.positioning.title'"></h2>

<kiwi-spacer [size]="24"></kiwi-spacer>

<h3 [i18nKey]="'intro.positioning.category.1'"></h3>

<p [i18nKey]="'intro.positioning.paragraph.1'"></p>

<b class="_primary"[i18nKey]="'intro.positioning.subtitle.1'"></b>
<p [i18nKey]="'intro.positioning.paragraph.2'"></p>

<b class="_primary"[i18nKey]="'intro.positioning.subtitle.2'"></b>
<p [i18nKey]="'intro.positioning.paragraph.3'"></p>

<b class="_primary"[i18nKey]="'intro.positioning.subtitle.3'"></b>
<p [i18nKey]="'intro.positioning.paragraph.4'"></p>

<kiwi-spacer [size]="16"></kiwi-spacer>

<h3 [i18nKey]="'intro.positioning.category.2'"></h3>

<p [i18nKey]="'intro.positioning.paragraph.5'"></p>

<p [i18nKey]="'intro.positioning.paragraph.6'"></p>

<b class="_primary"[i18nKey]="'intro.positioning.subtitle.4'"></b>

<p [i18nKey]="'intro.positioning.paragraph.7'"></p>

<ul>
    <li [i18nKey]="'intro.positioning.element.1'"></li>
    <li [i18nKey]="'intro.positioning.element.2'"></li>
</ul>

<p [i18nKey]="'intro.positioning.paragraph.8'"></p>

<b class="_primary"[i18nKey]="'intro.positioning.subtitle.5'"></b>

<p [i18nKey]="'intro.positioning.paragraph.9'"></p>

<ul>
    <li [i18nKey]="'intro.positioning.element.3'"></li>
    <li [i18nKey]="'intro.positioning.element.4'"></li>
</ul>

<p [i18nKey]="'intro.positioning.paragraph.10'"></p>

<div class="infoImg"></div>

<kiwi-spacer [size]="16"></kiwi-spacer>

<p [i18nKey]="'intro.positioning.paragraph.11'"></p>

<div class="graphImg cell small-24"></div>

<kiwi-spacer [size]="24"></kiwi-spacer>

<h3 [i18nKey]="'intro.positioning.category.3'"></h3>

<p [i18nKey]="'intro.positioning.paragraph.12'"></p>
<p [i18nKey]="'intro.positioning.paragraph.13'"></p>

<ul>
    <li [i18nKey]="'intro.positioning.element.5'"></li>
    <li [i18nKey]="'intro.positioning.element.6'"></li>
    <li [i18nKey]="'intro.positioning.element.7'"></li>
</ul>
